import { memo } from 'react';
import { useTranslation } from '@betty/i18n';
import { formatAmount } from '@betty/toolkit/utils';
import { PaymentStatusStartedProps } from './PaymentStatusStarted.types';
import PaymentMethodVerificationRequired from './PaymentMethodVerificationRequired/PaymentMethodVerificationRequired';
import PaymentMethodVerificationPending from './PaymentMethodVerificationPending/PaymentMethodVerificationPending';
import PaymentStatusBase from '../PaymentStatusBase/PaymentStatusBase';

function PaymentStatusStarted(props: PaymentStatusStartedProps) {
  const { amount, messageCode, transactionType } = props;
  const { t } = useTranslation('wallet');
  const context = { context: transactionType.toLowerCase() };

  if (messageCode === 'additional-payment-method-verification-required') {
    return <PaymentMethodVerificationRequired {...props} />;
  }

  if (messageCode === 'payment-method-document-pending-review') {
    return <PaymentMethodVerificationPending {...props} />;
  }

  return (
    <PaymentStatusBase
      title={t('paymentStatusPendingTitle', {
        amount: formatAmount(amount),
        ...context,
      })}
      description={t('paymentStatusPendingDescription', context)}
    />
  );
}

export default memo(PaymentStatusStarted);
